import * as T from 'io-ts';
import { VoteStatusT } from './Vote';
import { LuxonDateTimeT } from '../../SpecificCodecs/LuxonDateTime';
import { fromNullable } from 'io-ts-types/lib/fromNullable';
export const OptionalPlayerDetailsT = T.partial({
    photoURL: T.string,
});
export const RequiredPlayerDetailsT = T.type({
    name: T.string,
    uid: T.string,
    lastSeen: LuxonDateTimeT,
    vote: fromNullable(VoteStatusT, 'pending'),
});
export const PlayerT = T.intersection([RequiredPlayerDetailsT, OptionalPlayerDetailsT]);
export const PartialPlayerT = T.intersection([
    T.partial(RequiredPlayerDetailsT.props),
    OptionalPlayerDetailsT,
]);
export const PlayerArrayT = T.array(PlayerT);
